var _defs, _style, _defs2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "449.7879 155 246.4241 246.7029",
    width: 49.94349478664418,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".aIptOCySncolors-0i3cKVl1eJ {fill:#DD304A;fill-opacity:1;}.axMARv8He80filter-flooi3cKVl1eJ {flood-color:#EDEDED;flood-opacity:0.5;}")), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: -1000,
    y: -1000,
    width: 5000,
    height: 5000,
    id: "i3cKVl1eJxMARv8He8",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "rotate(0 449.7879 155)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 246.4241,
    height: 246.7029,
    x: 449.7879,
    y: 155,
    preserveAspectRatio: "none",
    viewBox: "5.800000190734863 5.800000190734863 88.29999542236328 88.39999389648438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    className: "aIptOCySncolors-0i3cKVl1eJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,94.2c11.8,0,22.9-4.6,31.2-12.9c8.3-8.3,12.9-19.4,12.9-31.2s-4.6-22.9-12.9-31.2C72.9,10.4,61.8,5.8,50,5.8 c-11.8,0-22.9,4.6-31.2,12.9C10.4,27.1,5.8,38.2,5.8,50s4.6,22.9,12.9,31.2C27.1,89.6,38.2,94.2,50,94.2z M21.7,69l8-13.8 c0.4,1.5,0.9,2.9,1.6,4.2l14.1,24.4C35.6,82.4,27,76.9,21.7,69z M36.9,50c0-7.2,5.9-13.1,13.1-13.1c1.7,0,3.1,1.4,3.1,3.1 c0,1.7-1.4,3.1-3.1,3.1c-3.8,0-6.8,3.1-6.8,6.8c0,1.7-1.4,3.1-3.1,3.1S36.9,51.7,36.9,50z M52.5,84l-8.1-13.8 c1.3,0.4,2.7,0.6,4.2,0.7l28.3,0C71.1,78.3,62.4,83.3,52.5,84z M81.6,37.2c1.6,3.9,2.5,8.3,2.5,12.8c0,5.4-1.2,10.4-3.5,15h-16 c1.1-1.1,2-2.2,2.9-3.5l0,0l0.4-0.7c0.1-0.2,0.2-0.3,0.3-0.5L81.6,37.2z M78.3,31l-8,13.8c-0.6-2.3-1.6-4.5-2.9-6.4L54.5,16.2 C64.4,17.5,73,23.1,78.3,31z M47.5,16l8,13.8c-1.5-0.4-3-0.6-4.6-0.7l-27.7,0C28.9,21.7,37.6,16.8,47.5,16z M15.9,50 c0-5.4,1.2-10.4,3.5-15h16c-1.1,1.1-2,2.2-2.9,3.5L32,39.3c-0.1,0.2-0.2,0.3-0.3,0.5l-13.3,23C16.8,58.8,15.9,54.5,15.9,50z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixar);
export default __webpack_public_path__ + "static/media/pixar.757bcfbd.svg";
export { ForwardRef as ReactComponent };